import React from 'react';
import { Chip } from '@mui/material';

const map = {
  Pending: { color: 'warning', label: 'Pending' },
  PendingDM: { color: 'warning', label: 'Pending (DM)' },
  PendingBoard: { color: 'warning', label: 'Pending (Board)' },
  CancelRequested: { color: 'secondary', label: 'Cancel Requested' },
  Approved: { color: 'success', label: 'Approved' },
  Rejected: { color: 'error', label: 'Rejected' },
  Cancelled: { color: 'default', label: 'Cancelled' },
  CancelRejected: { color: 'error', label: 'Cancel Rejected' },
};

export default function StatusChip({ status, size='small' }){
  const s = status || '';
  const conf = map[s] || { color:'default', label:s };
  return <Chip size={size} color={conf.color} label={conf.label} variant={conf.color==='default'?'outlined':'filled'} />;
}

